import type { Label } from '../../../shared/model-typings/label';
import type { OrganizationDomain } from '../../../shared/model-typings/organizationdomain';
import type { PendingDomainToken } from '../../../typings/api';
import type { AsyncStatus, Organization } from '../../types';

import actions from './actions';
import * as reducer from './reducer';
import * as selectors from './selectors';

export type OrganizationsStore = {
  organizations: Record<number, Organization>;
  status: AsyncStatus;
  pendingOrgDomains: {
    tokens: PendingDomainToken[];
    resendingEmailTokenIds: number[];
    status: AsyncStatus;
  };
  orgDomains: {
    domains: OrganizationDomain[];
    status: AsyncStatus;
  };
  ssoConfigurationStatus: AsyncStatus;
  creatingAuditReportLoading: boolean;
  labels: {
    status: AsyncStatus;
    labels: Label[];
  }
};

export default { actions, reducer, selectors };
